var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ec3mBoeC06r1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(11.951166 0 0 8.754937-91.185221-49.956739)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 76.5625,
    rx: 0,
    ry: 0,
    transform: "matrix(.835248 0-.091236 0.250668 14.615075 44.089658)",
    fill: "#0e9e00",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 76.5625,
    rx: 0,
    ry: 0,
    transform: "matrix(.835248 0-.091236 0.250668 21.600307 24.89789)",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 76.5625,
    rx: 0,
    ry: 0,
    transform: "matrix(.835248 0-.091236 0.250668 28.585539 5.706122)",
    fill: "#f66c00",
    strokeWidth: 0
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8fa5bbe7668dea84beb30abe9ac90509.svg";
export { ForwardRef as ReactComponent };